<template>
    <DateComp
        v-if="isValidDate(value)"
        :value="value"
        format="DATETIMESHORT"
    />
</template>

<script setup lang="ts">
import type { FocusEvent } from '@/objects/generated';
import FromToHelper from './FromToHelper.vue';
import { DateComp } from '@/components';

const props = defineProps<{
    value: Date | null;
    row: FocusEvent;
}>();

/**
 * Valid signupdate is date not null and later than 2020-01-01
 * @param date
 */
const isValidDate = (date: Date | null) => {
    return date != null && date > new Date('2020-01-01');
};
</script>
